import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { MailWarning, ChevronRight, X } from "lucide-react";
import { fetchTwoFactor } from "../lib/api";
import { useSecurity } from "../context/SecurityContext";
import { tr } from "../lib/i18n";

const KEY = "hv:recovery-nudge-dismissed";

// Owner-only nudge: alerts, weekly notes and reminders can't reach a placeholder address.
export const RecoveryEmailNudge = () => {
  const { role } = useSecurity();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(KEY) === "1");
  const { data } = useQuery({ queryKey: ["two-factor"], queryFn: fetchTwoFactor, enabled: role === "owner" || role === "admin" });
  if ((role !== "owner" && role !== "admin") || dismissed || !data?.needs_real_email) return null;
  const close = () => { sessionStorage.setItem(KEY, "1"); setDismissed(true); };
  return (
    <div className="mb-6 flex items-start gap-3 rounded-2xl border border-amber-300 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/30 p-4" data-testid="recovery-email-nudge">
      <MailWarning className="h-5 w-5 text-amber-700 dark:text-amber-400 shrink-0 mt-0.5" />
      <div className="flex-1 text-sm">
        <div className="font-medium">{data.email_hint ? "Your recovery email looks like a placeholder" : "Add a recovery email"}</div>
        <p className="text-muted-foreground text-xs mt-0.5">{data.email_hint ? `Alerts, weekly notes and reminders are going to ${data.email_hint}, which can't receive mail.` : "Unlock codes, emergency notices, guestbook alerts and reminders all need somewhere to land."} {tr("Set a real address so nothing gets lost.")}</p>
        <Link to="/vault?open=security" className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-primary hover:underline" data-testid="recovery-email-nudge-link" onClick={close}>{tr("Set recovery email")} <ChevronRight className="h-3.5 w-3.5" /></Link>
      </div>
      <button onClick={close} className="text-muted-foreground hover:text-foreground" aria-label={tr("Dismiss")} data-testid="recovery-email-nudge-dismiss"><X className="h-4 w-4" /></button>
    </div>
  );
};
